import { CompactTableRow } from 'components/data_table/CompactTableRow';
import { FullTableRow } from 'components/data_table/FullTableRow';
import { BaseTableHeaderFooter, DataAndKey } from 'components/data_table/types';

export type TableBodyProps<TData> = BaseTableHeaderFooter<TData> &
    Readonly<{
        /**
         * All row data and keys.
         */
        dataAndKeys?: DataAndKey<TData>[];
    }>;

export function TableBody<TData>({
    tableStyle,
    isCompact,
    columns,
    primaryColumns,
    secondaryColumns,
    lockStyles,
    dataAndKeys,
}: TableBodyProps<TData>) {
    return (
        <tbody>
            {isCompact
                ? dataAndKeys?.map(({ rowKey, rowData }, rowIndex) => (
                      <CompactTableRow
                          key={rowKey}
                          ariaDescription={`${rowKey}`}
                          tableStyle={tableStyle}
                          primaryColumns={primaryColumns}
                          secondaryColumns={secondaryColumns}
                          valueCell={(columnInfo) =>
                              columnInfo.value({
                                  rowData,
                                  rowIndex,
                                  columnInfo,
                                  isCompact: true,
                              })
                          }
                      />
                  ))
                : dataAndKeys?.map(({ rowKey, rowData }, rowIndex) => (
                      <FullTableRow
                          key={rowKey}
                          tableStyle={tableStyle}
                          columns={columns}
                          lockStyles={lockStyles}
                          valueCell={(columnInfo) =>
                              columnInfo.value({
                                  rowData,
                                  rowIndex,
                                  columnInfo,
                                  isCompact: false,
                              })
                          }
                      />
                  ))}
        </tbody>
    );
}
